module.exports = __webpack_public_path__ + "static/media/4_6.8b4f2b79.png";